module.exports = __webpack_public_path__ + "img/Pay-As-You-Go-HD-TV-Anywhere-You-Travel-with-DISH-Outdoors.310c182a.jpg";